import { useCallback, useEffect, useState } from "react";
import doorIcon from "../../assets/images/door.svg";
import carImage from "../../assets/images/economy-car-image.png";
import fuelIcon from "../../assets/images/fuel.svg";
import meterIcon from "../../assets/images/mileage-meter.svg";
import routeIcon from "../../assets/images/route.svg";
import snowflakeIcon from "../../assets/images/snowflake.svg";
import userIcon from "../../assets/images/user.svg";
import { FleetModel } from "../../models/fleet.model";
import Tooltip from "../Tooltip/Tooltip";
import style from "./CarDetail.module.scss";

const CarDetails = ({ fleetId }: { fleetId: string | null }) => {
  const [fleetData, setFleetData] = useState<FleetModel | null>(null);

  const getFleetId = useCallback(async (id: string) => {
    try {
      // For now, we'll need to implement a different approach
      // Since we don't have a single vehicle endpoint yet, we'll handle this differently
      // TODO: Implement single vehicle fetch or use a different approach
      console.warn('Vehicle fetching by ID not implemented yet. ID:', id);
      // Temporary placeholder - you might want to fetch from a different source or disable this
      setFleetData(null);
    } catch (error) {
      console.error('Error fetching vehicle:', error);
    }
  }, []);

  useEffect(() => {
    if (!fleetId) return;
    getFleetId(fleetId);
  }, [fleetId, getFleetId]);

  return (
    <div className={style.carDetail}>
      <span className={style.carDetail__tag}>Great Deal</span>
      <h3>{fleetData?.type}</h3>
      <p>{fleetData?.vehicleName}</p>

      <picture className={style.carDetail__car}>
        <img src={carImage} alt="Car" />
      </picture>
      <div className={`${style.carDetail__about} flex-wrap justifybetween`}>
        <div className={`${style.carDetail__info} flex-wrap`}>
          <aside>
            <div className={`${style.carDetail__infoText} flex align-center`}>
              <img src={userIcon} alt="Person" />
              <span>{fleetData?.sittingCapacity} Passengers</span>
            </div>
            <div className={`${style.carDetail__infoText} flex align-center`}>
              <img src={snowflakeIcon} alt="snowflake" />
              <span>Air conditioning</span>
            </div>
            <div className={`${style.carDetail__infoText} flex align-center`}>
              <img src={meterIcon} alt="meter" />
              <span>
                {fleetData?.costPerUnit?.currencyCode}{" "}
                {fleetData?.costPerUnit.amount}/mile
              </span>
            </div>
          </aside>
          <aside>
            <div className={`${style.carDetail__infoText} flex align-center`}>
              <img src={doorIcon} alt="doors" />
              <span>{fleetData?.numberOfDoors} Doors</span>
            </div>

            <div className={`${style.carDetail__infoText} flex align-center`}>
              <img src={routeIcon} alt="route" />
              <span>{fleetData?.transmissionType}</span>
            </div>
            <div className={`${style.carDetail__infoText} flex align-center`}>
              <img src={fuelIcon} alt="fuel" />
              <Tooltip
                className={"isFuel"}
                placeholderContent={<span>Fuel</span>}
                infoText=""
              ></Tooltip>
            </div>
          </aside>
        </div>

        <picture>
          <img src={fleetData?.image ? fleetData.image : carImage} alt="Car" />
        </picture>
      </div>
    </div>
  );
};
export default CarDetails;
